export interface CustomDeeplinkProps {
    customDeeplink?: string
}

export const DEEPLINK_CONSTANTS = {
    BASE_URL: 'https://neotaste.go.link',
    VOUCHER_PATH: '/profile/settings/voucher',
    RESTAURANT_DETAILS_PATH: '/discover/restaurantdetails',
    DEFAULT_ADJ_T: '1ip4ym1u',

    MARKETING_ADJ_T: '1qvjwnb4',
} as const

export const buildVoucherDeeplink = (code: string) => {
    const params = new URLSearchParams({
        voucherCode: code,
    })
    return `${DEEPLINK_CONSTANTS.BASE_URL}${DEEPLINK_CONSTANTS.VOUCHER_PATH}?${params.toString()}&adj_t=${DEEPLINK_CONSTANTS.DEFAULT_ADJ_T}`
}

interface VoucherClaimAdjustLinkParams {
    code: string
    utmSource?: string
    utmMedium?: string
    utmCampaign?: string
    adjustCampaign?: string
    adjustAdgroup?: string
    adjustCreative?: string
    clickId?: string
}

/**
 * The download link for a campaign landing page. Same go.link shape as
 * `buildVoucherDeeplink` and as the voucher page in open-web, so it deeplinks
 * straight into the voucher screen and falls back to the store on a fresh
 * install.
 *
 * Differs from `buildVoucherDeeplink` in two ways: it runs on the token
 * marketing measures installs with rather than the web one, and it forwards the
 * campaign parameters the visitor arrived with so the install can be traced back
 * to the ad that produced it.
 */
export const buildVoucherClaimAdjustLink = ({
    code,
    utmSource,
    utmMedium,
    utmCampaign,
    adjustCampaign,
    adjustAdgroup,
    adjustCreative,
    clickId,
}: VoucherClaimAdjustLinkParams) => {
    const params = new URLSearchParams({
        voucherCode: code,
        adj_t: DEEPLINK_CONSTANTS.MARKETING_ADJ_T,
    })

    const optional: Record<string, string | undefined> = {
        adj_campaign: adjustCampaign ?? utmCampaign,
        adj_adgroup: adjustAdgroup,
        adj_creative: adjustCreative,
        adj_label: clickId,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
    }

    for (const [key, value] of Object.entries(optional)) {
        if (value) params.set(key, value)
    }

    return `${DEEPLINK_CONSTANTS.BASE_URL}${DEEPLINK_CONSTANTS.VOUCHER_PATH}?${params.toString()}`
}

export const buildRestaurantDeeplink = (restaurantSlug: string) => {
    const params = new URLSearchParams({
        slug: restaurantSlug,
        adj_t: DEEPLINK_CONSTANTS.DEFAULT_ADJ_T,
    })
    return `${DEEPLINK_CONSTANTS.BASE_URL}${DEEPLINK_CONSTANTS.RESTAURANT_DETAILS_PATH}?${params.toString()}`
}
